import { render, staticRenderFns } from "./speaker.vue?vue&type=template&id=d89e7826&scoped=true"
import script from "./speaker.vue?vue&type=script&lang=js"
export * from "./speaker.vue?vue&type=script&lang=js"
import style0 from "./speaker.vue?vue&type=style&index=0&id=d89e7826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89e7826",
  null
  
)

export default component.exports